import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {UntypedFormGroup} from '@angular/forms';
import {UserSummary} from '../../entity/userSummary.model';
import {AuthService} from '../../../../../../auth/api/service/auth.service';
import {UserPaginatedService} from '../../service/userPaginated.service';
import {UserSummaryPaginatedService} from "../../service/userSummaryPaginated.service";

@Component({
  selector: 'app-user-select-filter',
  templateUrl: './user-select-filter.component.html',
  providers: [
    UserSummaryPaginatedService
  ]
})
export class UserSelectFilterComponent implements OnDestroy, AfterViewInit, OnChanges {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() multiple = false;
  @Input() active = true;
  @Input() role: string;
  @Input() userToIncludes: UserSummary[] = [];

  @Output() userElementsChangeEvent: EventEmitter<UserSummary[]> = new EventEmitter<UserSummary[]>();
  @Output() userSelectedEvent: EventEmitter<UserSummary> = new EventEmitter<UserSummary>();

  users: UserSummary[] = [];
  subscription: Subscription;
  constructor(public service: UserSummaryPaginatedService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['role'] || changes['active']) {
        this.refresh();
      }
  }



    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    ngAfterViewInit() {
      this.subscription = this.service.page$.subscribe(pagedUsers => {
        this.users = [];
        if (pagedUsers) {
          // console.log(['role', this.role]);
          this.users = pagedUsers.content
              .filter(value => value.active === this.active)
              .filter(value => !this.role || value.role?.value === this.role);
        }

        console.log(['userToIncludes', this.userToIncludes]);
        if (this.userToIncludes) {
          this.userToIncludes.forEach(value => {
            if (!this.users.find(value1 => value1.id === value.id)) {
              this.users.push(value);
            }
          })
        }
        this.users.sort((a, b) => a.name.localeCompare(b.name));
        this.userElementsChangeEvent?.emit(this.users);
      });
      this.refresh();
    }

    refresh() {
      this.service.refresh();
    }


  filter = (criteria: string, user: UserSummary) => {
    return (user.name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

}
